/**
 * Styled Components - Created by cazarez on 21/03/18.
 */
import styled from 'styled-components'

export const Container = styled.div`
  padding: 2px;
`

export const Text = styled.div`
  color: #fff;
`

export const ShareLinkContainer = styled.div`
  flex: 2;
  width: 100%;
`

export const QRCodeDiv = styled.div`
  width: 28px;
  &:hover {
    cursor: pointer;
  }
`
export const QrCodeIcon = styled.img`
  width: 28px;
  filter: hue-rotate(45deg);
`

export const Title = styled.div`
  margin-bottom: 5px;
  color: #5f6062;
  font-size: 14px;
  line-height: 19px;
  @media (max-width: 698px) {
    white-space: nowrap;
  }
`
export const Asterisk = styled.span`
  color: #e61737;
  font-size: 12px;
  line-height: 16px;
  margin-left: 5px;
`
export const ShareInputWrapper = styled.div`
  input {
    border-radius: 0;
  }
  .ant-btn {
    border-radius: 0;
    background-color: #4a90e2;
    border-color: #4a90e2;
    &:hover {
      background-color: #4a90e2;
      border-color: #4a90e2;
    }
  }
`

export const InputWrapper = styled.div`
  .ant-input {
    margin-bottom: 26px;
    height: 40px;
    border-radius: 0;
    color: #bebebe;
    font-size: 16px;
    line-height: 22px;
  }
`

export const ShareSocialMediaContainer = styled.div`
  text-align: center;
  margin-right: 54px;
  @media (max-width: 698px) {
    margin-right: 8px;
  }
`
export const ShareByMailRow = styled.div``

export const IconsRow = styled.div`
  margin-top: 15px;
  display: flex;
  justify-content: center;
  gap: 12px;
  @media (max-width: 698px) {
    margin-top: 12px;
  }
`

export const RowShare = styled.div`
  margin-top: 12px;
  display: flex;
  justify-content: center;
  @media (max-width: 368px) {
    flex-wrap: wrap;
  }
`

export const FacebookIconImg = styled.img`
  width: 28px;
  &:hover {
    cursor: pointer;
  }
`
export const TwitterIconImg = styled.img`
  width: 28px;
  &:hover {
    cursor: pointer;
  }
`

export const SendButtonWrapper = styled.div`
  text-align: right;
  .ant-btn {
    height: 40px;
    width: 138.23px;
    border-radius: 2px;
    background-color: #4a90e2;
    color: #fff;
  }
`

export const SendEmailButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  @media (max-width: 698px) {
    white-space: nowrap;
  }
`

export const SendEmailButton = styled.div`
  background-color: #4a90e2;
  padding: 8px 10px;
  width: fit-content;
  color: white;
  font-size: medium;
  font-weight: 400;
  border-radius: 5px;
  box-shadow: 1px 1px 3px 1px lightgray;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    background-color: white;
    color: #4a90e2;
  }
`

export const SendIcon = styled.img`
  max-width: 20px;
  margin-left: 8px;
  vertical-align: bottom;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/ShareDesignModal/styledComponents.tsx